module monitoringApp.components {
    //@ts-ignore
    class ReportLineChartComponentController implements ng.IComponentController {

        private axisXLabel: string;
        private axisYLabel: string;
        private passedData: Array<[number, number]> = [];
        private failedData: Array<[number, number]> = [];
        private runsData: Array<[number, number]> = [];

       

        constructor(private $timeout) {
            this.lineOptions.chart.xAxis.axisLabel = this.axisXLabel;
            this.lineOptions.chart.yAxis.axisLabel = this.axisYLabel;
            console.log(this)
        }

        $inject = ['$timeout'];

        private lineOptions = {
            chart: {
                type: 'lineChart',
                height: 450,
                margin: {
                    top: 20,
                    right: 20,
                    bottom: 40,
                    left: 55
                },
                x: function (d) { return d[0]; },
                y: function (d) { return d[1]; },
                useInteractiveGuideline: 1,
                dispatch: {
                },
                xAxis: {
                    ticks: 31,
                    axisLabel: "",
                },
                xDomain: [1, 31],
                yAxis: {
                    axisLabel: "",
                    axisLabelDistance: -10
                },
                callback: (chart) => {
                    this.refreshCharts();
                }
            }
        };

        private refreshCharts = () => {
            this.$timeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 0);
        }


        private lineData = () => {
            return [
                {
                    values: this.passedData,
                    key: 'Passed',
                    color: '#4CAF50'
                },
                {
                    values: this.failedData,
                    key: 'Failed',
                    color: '#f7464a'
                },
                {
                    values: this.runsData,
                    key: 'Runs',
                    color: '#90A4AE'
                }
            ];
        }
    }



    class ReportLineChart implements ng.IComponentOptions {

        public bindings: { [binding: string]: string } = {
            axisYLabel: "@",
            axisXLabel: "@",
            runsData: "=",
            failedData: "=",
            passedData: "="
        }

        public controller = ReportLineChartComponentController;

        constructor() {
        }

        public template =
        ` <nvd3 options="$ctrl.lineOptions" data="$ctrl.lineData" class="with-3d-shadow with-transitions"></nvd3>`;

    }

    angular.module("ultimateMonitoringApp").component("reportLineChart", new ReportLineChart());
}